export default {
      id: "oc-resource-manage-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-resource-manage",
      toString: function () {
        return this.url;
      }
    }